import KeyIdentifier from '@exodus/key-identifier'
import assert from 'minimalistic-assert'

const SUPPORTED_MODES = new Set([
  'phantom',
  'metamask',
  'trezor',
  'trust',
  'mathwallet',
  'ordinals86',
  'ordinals84',
  'xverse49NotMerged',
  'xverse49',
])

export class KeyIdentifierProvider {
  #compatibilityMode

  constructor({ compatibilityMode = null } = {}) {
    this.#compatibilityMode = compatibilityMode
  }

  setCompatibilityMode = (compatibilityMode) => {
    assert(
      compatibilityMode === null || SUPPORTED_MODES.has(compatibilityMode),
      'Invalid compatibilityMode'
    )

    this.#compatibilityMode = compatibilityMode
  }

  getCompatibilityMode = () => {
    return this.#compatibilityMode
  }

  createKeyIdentifier = ({ asset, purpose, accountIndex, addressIndex, chainIndex }) => {
    assert(asset && typeof asset === 'object', 'Invalid asset was passed')

    const baseAsset = asset.baseAsset

    const keyId = baseAsset.api.getKeyIdentifier({
      purpose,
      accountIndex,
      addressIndex,
      chainIndex,
      compatibilityMode: this.#compatibilityMode,
    })

    return new KeyIdentifier(keyId)
  }
}

const createKeyIdentifierProvider = (opts) => new KeyIdentifierProvider(opts)

export default createKeyIdentifierProvider
